import type { CSSProperties } from 'react';

/**
 * Single z-index scale for portaled/fixed UI. Higher = closer to the user.
 *
 * | Layer              | Typical use |
 * |--------------------|-------------|
 * | mobileSidebarOverlay | Dim behind mobile drawer |
 * | shellSidebar       | Fixed app `<aside>` |
 * | topMenuBackdrop    | Top-menu layout click-away |
 * | topMenuDropdown    | Top-menu flyout menu |
 * | portaledDropdown   | Module toolbars (email filters, recipient picker, …) |
 * | shellFlyout*       | Collapsed rail drawers (app Sidebar, email folders) |
 * | shellFlyoutNested  | Submenus anchored to rail (e.g. Views) |
 * | modal*             | Blocking dialogs (above rail flyouts) |
 * | toast              | Toasts / chat notifications |
 */
export const Z_INDEX = {
  mobileSidebarOverlay: 30,
  /** Local stacking inside a scroll region (non-portal) */
  localDropdown: 30,
  shellSidebar: 40,
  topMenuBackdrop: 40,
  topMenuDropdown: 50,
  /** Portaled menus below shell flyouts; above main chrome */
  portaledDropdown: 5000,
  shellFlyoutBackdrop: 10040,
  shellFlyoutPanel: 10045,
  shellFlyoutNested: 10050,
  accountPopover: 10050,
  modalBackdrop: 10100,
  modal: 10110,
  /** Print preview, AI drawer, etc. */
  modalHigh: 10200,
  toast: 10300,
} as const;

export function zStyle(z: number): CSSProperties {
  return { zIndex: z };
}
